import { DOC_TYPE, KEYS_TAGS } from '@components/imageHandling/common';
import { ScaleFunction } from '@components/operatorPanel/interfaces';

export const OPERATOR_PANEL_PADDING = 18;
export const OPERATOR_PANEL_HEADER_HEIGHT = 90;
export const OPERATOR_PANEL_HOME_SCREEN_BUTTON_WIDTH = 168;
export const OPERATOR_PANEL_HOME_SCREEN_BUTTON_HEIGHT = 120;

export const OPERATOR_PANEL_SETTINGS_CONFIG = {
  header: {
    right: 59 + OPERATOR_PANEL_PADDING,
    top: 16,
  }
}

export enum OPERATOR_PANEL_INFORMATION_SCREENS {
  Information = 'OperatorPanelInformationScreen',
  Jobs = 'OperatorPanelInformationJobsScreen',
  NcFiles = 'OperatorPanelInformationNcFilesScreen',
  Setup = 'OperatorPanelInformationSetupScreen',
  Tools = 'OperatorPanelInformationToolsScreen',
  Notes = 'OperatorPanelInformationNotesScreen',
  '2DDrawing' = 'OperatorPanelInformation2DDrawingScreen',
  '3DDrawing' = 'OperatorPanelInformation3DDrawingScreen',
  Clamping = 'OperatorPanelInformationClampingScreen',
  Part = 'OperatorPanelInformationPartScreen',
  Material = 'OperatorPanelInformationMaterialScreen',
  ProductionOrder = 'OperatorPanelInformationProductionOrderScreen',
  Measurement = 'OperatorPanelInformationMeasureScreen',
  AllDocuments = 'OperatorPanelInformationDocumentsScreen',
  Scheduled = 'OperatorPanelScheduledScreen',
  SearchNCFiles = 'OperatorPanelInformationSearchNCFilesScreen',
  SearchHistory = 'OperatorPanelInformationSearchHistoryScreen',
}

export const DOC_TYPE_TO_SCREEN = {
  [DOC_TYPE['2D_DRAWING']]: OPERATOR_PANEL_INFORMATION_SCREENS['2DDrawing'],
  [DOC_TYPE['3D_DRAWING']]: OPERATOR_PANEL_INFORMATION_SCREENS['3DDrawing'],
  [DOC_TYPE.NOTE]: OPERATOR_PANEL_INFORMATION_SCREENS.Notes,
  [DOC_TYPE.SETUP_SHEET]: OPERATOR_PANEL_INFORMATION_SCREENS.Setup,
  // [DOC_TYPE.MATERIAL_CERTIFICATE]: OPERATOR_PANEL_INFORMATION_SCREENS.Material,
  [DOC_TYPE.MEASUREMENT_REPORT]: OPERATOR_PANEL_INFORMATION_SCREENS.Measurement,
  [DOC_TYPE.GENERAL_DOCUMENT]: OPERATOR_PANEL_INFORMATION_SCREENS.AllDocuments,
  [DOC_TYPE.CLAMPING_IMAGE]: OPERATOR_PANEL_INFORMATION_SCREENS.Clamping,
  [DOC_TYPE.PART_IMAGE]: OPERATOR_PANEL_INFORMATION_SCREENS.Part,
};

export const SCOPE_ID_TO_SCREEN = {
  [KEYS_TAGS.Part]: {
    screen: OPERATOR_PANEL_INFORMATION_SCREENS.Part,
  },
  [KEYS_TAGS.ProductionOrder]: {
    screen: OPERATOR_PANEL_INFORMATION_SCREENS.ProductionOrder,
    param: 'selectedProductionOrderId',
  },
  [KEYS_TAGS.Operation]: {
    screen: OPERATOR_PANEL_INFORMATION_SCREENS.Jobs,
  },
  [KEYS_TAGS.Clamping]: {
    screen: OPERATOR_PANEL_INFORMATION_SCREENS.Clamping,
  },
  [KEYS_TAGS.Tool]: {
    screen: OPERATOR_PANEL_INFORMATION_SCREENS.Tools,
  },
};

export const scheduledProductionOperationIdParam = 'scheduledProductionOperationId';

export enum OP_DOCUMENTS_DISPLAY_MODE {
  TILE = 'tile',
  GALLERY = 'gallery',
}

export const FORCE_RETRIEVE_FROM_SOURCE_KEY_EXPIRATION_TIME = 'forceRetrieveFromSourceKey';

export const THREE_D_DRAWING_EXTENSIONS_TO_DISPLAY = ['glb'];

export const MACHINE_FILTER_PARAM = 'machineFilter'; 

export const NC_FILE_POPUP_CONFIG = {
  maxWidthBreakPoint: 1116,
  widthOffsetInCaseBreakpoint: 36,
  verticalOffset: 18,
}

export const SCHEDULED_FILTER_TYPE_MAP: Record<string, 'machine' | 'matched' | 'all'> = {
  machine: 'machine',
  operation: 'matched',
  all: 'all',
};

export const getHomePageNCFileButtonsCommonStyle = (scale: ScaleFunction) =>
  ({
    textFont: 'Headline',
    buttonContainerStyle: {
      width: scale(304),
      height: scale(60),
      paddingTop: scale(0),
      paddingBottom: scale(0),
      paddingHorizontal: scale(0),
      gap: scale(0),
      borderRadius: scale(18),
      justifyContent: 'center',
    },
  } as const);